let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eGbbV")).then(() => parcelRequire('7urIP'));